/* istanbul ignore file */
import React from 'react';
import { EnumField, FieldProps } from 'framework/ui/field';
import { useShowContext } from 'framework/show';
import { LEAD_STATUS } from 'domain/sales/lead/shared/leadService';

const LeadStatusField = ({ value: inputValue = null, source = null }: FieldProps) => {
  const { data } = useShowContext();

  const value = inputValue || (data && data.getValueBySource(source!));

  return <EnumField label="Lead status" value={value} options={LEAD_STATUS} />;
};

export default LeadStatusField;
